import * as ActionTypes from '../actions/ActionTypes';
import TemplatePreviewRecord from '../records/TemplatePreviewRecord';
const INITIAL_STATE = new TemplatePreviewRecord();
export default function templatePreview(state = INITIAL_STATE, {
  type
}) {
  switch (type) {
    case ActionTypes.TEMPLATE_PREVIEW_SHOW_LOADING_OVERLAY:
      return state.set('showLoadingOverlay', true);
    case ActionTypes.TEMPLATE_PREVIEW_TRIGGER_IFRAME_RELOAD:
      return state.set('triggerIFrameReload', true);
    case ActionTypes.TEMPLATE_PREVIEW_IFRAME_RELOAD_TRIGGERED:
      return state.merge({
        triggerIFrameReload: false,
        iframeLoading: true
      });
    case ActionTypes.TEMPLATE_EDITOR_IFRAME_LOADED:
    case ActionTypes.TEMPLATE_EDITOR_IFRAME_LOADING_ERROR:
      return state.merge({
        showLoadingOverlay: false,
        iframeLoading: false
      });
    case ActionTypes.TEMPLATE_PREVIEW_HIDE_LOADING_OVERLAY:
      return state.set('showLoadingOverlay', false);
    case ActionTypes.TEMPLATE_EDITOR_OPEN_TRANSLATE_TEMPLATE_MODAL:
      return state.set('iframePaused', true);
    case ActionTypes.TEMPLATE_EDITOR_CLOSE_TRANSLATE_TEMPLATE_MODAL:
      return state.set('iframePaused', false);
    default:
      return state;
  }
}